/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createRestoreTrashedImagesResponseFromDiscriminatorValue, serializeRestoreTrashedImagesRequest, serializeRestoreTrashedImagesResponse, type ErrorResponse, type InternalErrorResponse, type RestoreTrashedImagesRequest, type RestoreTrashedImagesResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/images/trash/restore
 */
export interface RestoreRequestBuilder extends BaseRequestBuilder<RestoreRequestBuilder> {
    /**
     * Deleted images sit in a trash - removed from the platform but kept in storage - until the retention purge removes them. This restores the given assets to full service at exactly the URLs they had. Ids not found in storage are skipped and omitted from the response. Note this restores the stored asset only - an image document or product assignment removed alongside the original delete is not recreated.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<RestoreTrashedImagesResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: RestoreTrashedImagesRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<RestoreTrashedImagesResponse | undefined>;
    /**
     * Deleted images sit in a trash - removed from the platform but kept in storage - until the retention purge removes them. This restores the given assets to full service at exactly the URLs they had. Ids not found in storage are skipped and omitted from the response. Note this restores the stored asset only - an image document or product assignment removed alongside the original delete is not recreated.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: RestoreTrashedImagesRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const RestoreRequestBuilderUriTemplate = "{+baseurl}/api/images/trash/restore";
/**
 * Metadata for all the requests in the request builder.
 */
export const RestoreRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: RestoreRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createRestoreTrashedImagesResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeRestoreTrashedImagesRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
